/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Error_Upstream_ErrorInputs */

const en_usage_error_upstream_error = /** @type {(inputs: Usage_Error_Upstream_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upstream error`)
};

const zh_hans1_usage_error_upstream_error = /** @type {(inputs: Usage_Error_Upstream_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上游错误`)
};

const pt_br2_usage_error_upstream_error = /** @type {(inputs: Usage_Error_Upstream_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro upstream`)
};

const es_usage_error_upstream_error = /** @type {(inputs: Usage_Error_Upstream_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error del proveedor`)
};

const fr_usage_error_upstream_error = /** @type {(inputs: Usage_Error_Upstream_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur en amont`)
};

const de_usage_error_upstream_error = /** @type {(inputs: Usage_Error_Upstream_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anbieterfehler`)
};

const ru_usage_error_upstream_error = /** @type {(inputs: Usage_Error_Upstream_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка источника`)
};

const it_usage_error_upstream_error = /** @type {(inputs: Usage_Error_Upstream_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore a monte`)
};

/**
* | output |
* | --- |
* | "Upstream error" |
*
* @param {Usage_Error_Upstream_ErrorInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const usage_error_upstream_error = /** @type {((inputs?: Usage_Error_Upstream_ErrorInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Error_Upstream_ErrorInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_usage_error_upstream_error(inputs)
	if (locale === "pt-BR") return pt_br2_usage_error_upstream_error(inputs)
	if (locale === "es") return es_usage_error_upstream_error(inputs)
	if (locale === "fr") return fr_usage_error_upstream_error(inputs)
	if (locale === "de") return de_usage_error_upstream_error(inputs)
	if (locale === "ru") return ru_usage_error_upstream_error(inputs)
	if (locale === "it") return it_usage_error_upstream_error(inputs)
	return en_usage_error_upstream_error(inputs)
});